// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2741":"724032bde111d079","9651":"7137cc383942b1db"}[chunkId] + ".js";
};